import { createFeatureSelector, createSelector } from '@ngrx/store';
import { APP_FEATURE_KEY, AppState } from '../reducers';

// Lookup the 'App' feature state managed by NgRx
const getAppState = createFeatureSelector<AppState>(APP_FEATURE_KEY);

export const isLoggedIn = createSelector(getAppState, (state: AppState) => state.isLoggedIn);

export const isLoading = createSelector(getAppState, (state: AppState) => state.isLoading);

export const isLoginLoading = createSelector(
  getAppState,
  (state: AppState) => state.isLoginLoading
);

export const propertyAddress = createSelector(getAppState, (state: AppState) => state.address);

export const estimatedCost = createSelector(getAppState, (state: AppState) => state.estimatedCost);

export const estimatedProjectCostInformation = createSelector(
  getAppState,
  (state: AppState) => state.monthlyCostInfo
);

export const companyPin = createSelector(getAppState, (state: AppState) => state.pin);

export const calculationParams = createSelector(
  estimatedCost,
  propertyAddress,
  (estimated_cost, address) => ({ estimated_cost, address, include_apr: true })
);
